// extracted by mini-css-extract-plugin
export default {"phone":"EQO0lLm1Nr7AO4f"};